const object = (value) => value !== null && typeof value === 'object' && !Array.isArray(value);
const equal = (left, right) => JSON.stringify(left ?? '') === JSON.stringify(right ?? '');

/** Refresh untouched fields while preserving changes the operator has not saved. */
export function mergeLiveRecord(current, previous, incoming) {
  const next = { ...current };
  for (const [key, value] of Object.entries(incoming || {})) {
    if (['__proto__', 'constructor', 'prototype', '_compact'].includes(key)) continue;
    if (object(value) && object(current?.[key])) next[key] = mergeLiveRecord(current[key], previous?.[key] || {}, value);
    else if (equal(current?.[key], previous?.[key])) next[key] = value;
  }
  return next;
}
